export enum AchievementSlug {
  FIRST_TOUCH = 'first_touch',
  FIRST_GLANCE = 'first_glance',
  ONE_OF_THE_VOICES = 'one_of_the_voices',
  NIGHT_SONG = 'night_song',
  RHYTHM_BEYOND_THE_LOOP = 'rhythm_beyond_the_loop',
  A_SIGN_RECOGNIZED = 'a_sign_recognized',
  WHOS_WATCHING = 'whos_watching',
  EYE_WAS_GIVEN = 'eye_was_given',
  HARLANS_GIFT = 'harlans_gift',
  MASTER_OF_TRIAL_AND_ERROR = 'master_of_trial_and_error',
  FACE_SELECTED = 'face_selected',
  LUCKY = 'lucky',
  TRANSACTION_COMPLETE = 'transaction_complete',
  SUFFERING_IS_OPTIONAL = 'suffering_is_optional',
}
